import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import StepToShowComponent from "../../components/Step";
import { SawasdeeProvider } from "./SawasdeeContext";
import { SpaceBox } from "../../components/Space";
import DecoratedGraphic from "../../images/graphic.png";
import PaymentErrorModalComponent from "../../components/PaymentErrorModal";
import { STEPS } from "../../data/international";
import OrderService from "../../service/order";
import InternationalStep1 from "./Step1";
import InternationalStep2 from "./Step2";
import InternationalStep3 from "./Step3";
import InternationalStep4 from "./Step4";
import InternationalStep5 from "./Step5";
import InternationalStep6 from "./Step6";
import InternationalStep7 from "./Step7";
import { CookieUtils, Alert, IdentityUtils } from "../../utils";
import moment from "moment";
import crypter from "../../utils/crypter";
import { TYPE_CODES } from "../../const";
import CalculateService from "../../service/calulate";
import ConsentPage from "./consent";

class InternationalPage extends Component {
  state = {
    showErroModal: false,
    errorTitle: "Payment is cancelled.",
    errorMessage: "Your payment session has expired, please return to merchant page and attempt payment again.",
    steps: STEPS,
    page: 0,

    step1: {
      type: null,
      start_date: "",
      end_date: "",
      counter: 1,
      purposeTour: "",
      purposeTourOther: "",
      usertype: 1,
      destinationCountry: "",
      visa: 0,
      countryZone: "",
      onChangeModel: (object, cb) => this.changeModelStep1(object, cb),
      onChangeDate: (object) => this.changeDate(object),
      onChangeZone: (object) => this.changeZone(object),
      onOneTrip: () => this.onOneTripSelect(),
      onYearTrip: () => this.onYearTripSelect(),
      getPlan: () => this.fetchPlan(),
      // onUpdatePlan: object => this.changePlanStep1(object)
    },
    step2: {
      planList: [],
      selectedPlan: "",
      acceptInsurance: false,
      acceptHealthCheck: false,
      onChangeModel: (object) => this.changeModelStep2(object),
    },
    step3: {
      insures: [
        {
          sNationality: { value: "THA", label: "Thailand" },
          sNo: "",
          sMoo: "",
          sSoi: "",
          sRoad: "",
          sProvince: "",
          sDistrict: "",
          sCity: "",
          sZipcode: "",
          sBuilding: "",
          benefits: [{ sInit: "", sFirstName: "", sLastName: "", sRelation: "" }],
          age: "",
        },
      ],
      onChangeModel: (object) => this.changeModelStep3Insurance(object),
      onChangeNationality: (object) => this.changeModelStep3Nationality(object),
      onChangeAddressOther: (object) => this.changeModelStep3AddressOther(object),
      onChangeBenefit: (object) => this.changeModelStep3Benefit(object),
      onAddBenefit: (key) => this.onHandleBenefit(key, "Add"),
      onRemoveBenefit: (key) => this.onHandleBenefit(key, "Remove"),
      onChangeModelProvinces: (object) => this.changeModelProvinces(object),
    },
    step4: {
      recieveEmail: true,
      recievePost: "",
      editKey: 0,
      confirmInsurance: "",
      onChangeModel: (object) => this.changeModelStep4Insurance(object),
      onEditUser: (object) => this.changeEditUser(object),
    },
    step5: {
      paymentModel: {},
    },
    step6: {
      onNavigate: (object) => this.onNavigate(object),
    },
    step7: {
      cName: "",
      cLastName: "",
      cMobile: "",
      cEmail: "",
      cReason: "",
      cDetail: "",
      cDate: "",
      cTime: "",
      onChangeModel: (object) => this.changeModelStep7(object),
      onNavigate: (object) => this.onNavigate(object),
    },
  };

  constructor(props) {
    super(props);
    this.initPage();
  }

  initPage() {
    let stateBack = localStorage.getItem("states_ta_sawasdee");
    let paymentResponse = CookieUtils.getCookie("pay_result_ta_sawasdee");
    if (paymentResponse && stateBack) {
      //decode
      if (window && window.decodeURIComponent) {
        paymentResponse = window.decodeURIComponent(paymentResponse);
        stateBack = window.decodeURIComponent(stateBack);
      }
      paymentResponse = crypter.decode(paymentResponse);
      stateBack = crypter.decode(stateBack);

      //Case Error
      const { payment_result } = paymentResponse;
      const isSuccess = payment_result.success;
      this.state.page = isSuccess ? 6 : 5;
      let { step1, step2, step3, step4, step5 } = this.state;
      step1 = { ...step1, ...stateBack.step1 };
      step2 = { ...step2, ...stateBack.step2 };
      step3 = { ...step3, ...stateBack.step3 };
      step4 = { ...step4, ...stateBack.step4 };
      step5 = { ...step5, ...stateBack.step5 };

      this.state = {
        ...this.state,
        step1,
        step2,
        step3,
        step4,
        step5,
        step6: {
          ...paymentResponse,
        },
      };

      if (!isSuccess) {
        this.state.showErroModal = true;
      }

      localStorage.setItem("states_ta_sawasdee", "");
      CookieUtils.setCookie("pay_result_ta_sawasdee", "");
    }
  }

  onOneTripSelect() {
    const { step1 } = this.state;
    if (step1.type) {
      step1.end_date = "";
    }
    step1.type = 1;
    this.setState({ ...this.state, step1 }, () => {
      this.fetchPlan();
    });
  }

  onYearTripSelect() {
    const { step1 } = this.state;
    step1.type = 2;

    if (step1.start_date) {
      const addYear = moment(step1.start_date).add(1, "years").subtract(1, "days").format("YYYY-MM-DDTHH:mm:ss");
      step1.end_date = addYear;
    } else {
      step1.end_date = "";
    }

    this.setState({ ...this.state, step1 }, () => {
      this.fetchPlan();
    });
  }

  onHandleBenefit(key, type) {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    if (type === "Add") {
      insures[key].benefits.push({
        sInit: "",
        sFirstName: "",
        sLastName: "",
        sRelation: "",
      });
      step3.insures = insures;
      this.setState({ ...this.state, step3 });
    } else if (type === "Remove") {
      const benefit = insures[key].benefits[0];
      insures[key].benefits = [benefit];

      step3.insures = insures;
      this.setState({ ...this.state, step3 });
    }
  }

  onNavigate = (page) => {
    const { step1, step3 } = this.state;
    if (page === 2) {
      step3.insures = [];
      for (let i = 1; i <= step1.counter; i++) {
        const field = {
          sNationality: { value: "THA", label: "Thailand" },
          sNo: "",
          sMoo: "",
          sSoi: "",
          sRoad: "",
          sProvince: "",
          sDistrict: "",
          sCity: "",
          sZipcode: "",
          benefits: [{ sInitNameTH: "", sFirstNameTH: "", sLastNameTH: "" }],
          isHeir: "",
        };
        step3.insures.push(field);
      }
    } else if (page === 4) {
      const { insures } = step3 || {};
      // const { sNationality } = insures[i];
      // console.log("insure", insures);
      for (let i = 0; i < step1.counter; i++) {
        const { sNationality } = insures[i];
        // console.log("sNationality", sNationality);
        if (sNationality && sNationality.value === "THA") {
          if (!this._validForm(step3.insures[i].sIDNo)) {
            return false;
          }
        }
      }
      if (!this._validEmail()) {
        return false;
      }
      if (step1.usertype === 2) {
        let min = 555;
        let max = 0;
        let countUnder = 0;
        for (let i = 0; i < step1.counter; i++) {
          const sBirthDate = step3.insures[i].sBirthDate;
          const diffDate = step3.insures[i].sBirthDate ? moment.utc().diff(moment(sBirthDate), "years") : "-";
          step3.insures[i].age = diffDate;
          if (diffDate > max) {
            max = diffDate;
          }
          if (diffDate < min) {
            min = diffDate;
          }
          if (diffDate < 21) {
            countUnder++;
          }
        }
        if (min >= 21 || max < 21 || countUnder > 1) {
          Alert.alertMessage(
            "กรุณากรอกข้อมูลให้ถูกต้อง",
            "แผนการเดินทางครอบครัว กำหนดให้ต้องมีผู้ใหญ่ 1 ท่าน (อายุ 21 ปีขึ้นไป) และเด็ก 1 ท่าน (อายุ 1 – 20 ปี) อยู่ในการเดินทางพร้อมกัน",
            "warning",
            "true",
            "แก้ไขข้อมูลผู้เอาประกัน",
            // "true",
            // "เปลี่ยนแผนการเดินทางรายเดี่ยว"
          ).then((res) => {
            if (res === "option1") {
              this.setState({ ...this.state, page: 3 }, () => window.scrollTo(0, 0));
            } else if (res === "option2") {
              step1.usertype = 1;
              this.setState({ ...this.state, step1 });
              this.changeFamilyPlan();
              this.setState({ ...this.state, page: 2 }, () => window.scrollTo(0, 0));
              // need to set usertype as 1 before display page 2 then re turn true;
              // return true;
            }
          });
          return true;
        }
      }
    } else if (page === 5) {
      this._onVerifyOrder();
      return;
    }
    this.setState({ ...this.state, page }, () => window.scrollTo(0, 0));
  };

  changeFamilyPlan = () => {
    const { step1 } = this.state;
    this.changeModelStep1({ ...this.state, step1 }, async () => {
      const diffDate =
        step1.start_date && step1.end_date ? moment(step1.end_date).diff(moment(step1.start_date), "days") + 1 : "-";
      try {
        if (diffDate && typeof diffDate === "number") {
          let plans = await CalculateService.rate({
            type_code: TYPE_CODES.HT,
            day: diffDate,
            counter: step1.counter,
            age: 1,
            zone: step1.countryZone,
            options: step1.usertype === 2 ? "F" : "S",
          });
          plans = plans.map((plan, i) => {
            return {
              ...plan,
              title: `ทุนประกัน (แผนที่ ${i + 1})`,
            };
          });
          this.changePlanStep1(plans); // change plan
          console.log("New plan: ", plans);
        }
      } catch (error) {
        console.log("Error: ", error);
      }
    });
  };

  //UI Action Step1
  changeModelStep1 = ({ name, value }, cb = () => {}) => {
    const { step1 } = this.state;
    step1[name] = value;
    this.setState({ ...this.state, step1 }, cb);
  };

  changePlanStep1 = (planList, cb) => {
    const { step2 } = this.state;
    step2.planList = planList;
    step2.selectedPlan = "";
    this.setState({ ...this.state, step2 }, cb);
  };

  changeDate = ({ name, value }) => {
    const { step1 } = this.state;
    step1[name] = value;
    if (step1.type === 2) {
      if (step1.start_date) {
        const addYear = moment(step1.start_date).add(1, "years").subtract(1, "days").format("YYYY-MM-DDTHH:mm:ss");
        step1.end_date = addYear;
      } else {
        step1.end_date = "";
      }
    }
    this.setState({ ...this.state, step1 }, () => this.fetchPlan());
  };

  changeZone = ({ name }) => {
    const { step1 } = this.state;
    const { destinationCountry } = step1;
    let Zone = "ASIA";
    step1[name] = Zone;

    this.setState({ ...this.state, step1 });
    if (destinationCountry) {
      for (let i = 0; i < destinationCountry.length; i++) {
        if (destinationCountry[i].zone === "WORLDWIDE") {
          Zone = "WORLDWIDE";
          step1[name] = Zone;
          this.setState({ ...this.state, step1 });
        }
      }
    }

    this.setState({ ...this.state, step1 }, () => this.fetchPlan());
  };

  async fetchPlan(cb) {
    const { step1 } = this.state;
    const diffDate = this.getDiffDate();
    if (diffDate && typeof diffDate === "number") {
      try {
        let plans = await this.callFetchPlans(diffDate, step1.counter);
        plans = plans.map((plan, i) => {
          return {
            ...plan,
            title: `ทุนประกัน (แผนที่ ${i + 1})`,
          };
        });
        console.log("plan change");
        this.changePlanStep1(plans, cb);
        Alert.hideLoading();
      } catch {
        Alert.hideLoading();
      }
    }
  }

  async callFetchPlans(diffDate, counter) {
    const { step1 } = this.state;
    try {
      Alert.showLoading();
      const data = await CalculateService.rate({
        counter,
        type_code: TYPE_CODES.TS,
        day: diffDate,

        age: 1,
        zone: step1.countryZone,
        options: step1.usertype === 2 ? "F" : "S",
      });
      if (data && data.length === 0) {
        this.callFetchPlans(diffDate, counter);
      }
      return data;
    } catch {
      return [];
    }
  }

  changeModelStep2 = ({ name, value }) => {
    const { step2 } = this.state;
    step2[name] = value;
    this.setState({ ...this.state, step2 });
  };

  changeModelStep3Insurance = ({ key, name, value }) => {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    insures[key][name] = value;
    step3.insures = insures;
    // if (value && name == "isHeirBenefit") {
    //   // declare benefit firstname as ทายาทโดยธรรม
    //   insures[key].benefits[index][name] = value;
    //   step3.insures = insures;
    //   this.setState({ ...this.state, step3 });
    // }
    this.setState({ ...this.state, step3 });
  };
  changeModelStep3Nationality = ({ key, name, value }) => {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    insures[key][name] = value;
    insures[key]["sIDNo"] = "";
    insures[key]["sPassportNo"] = "";
    insures[key]["sExpiryDate"] = "";
    step3.insures = insures;
    this.setState({ ...this.state, step3 });
  };
  changeModelProvinces = ({ key, addressChange }) => {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    const step3Change = {
      ...insures[key],
      ...addressChange,
    };
    step3.insures[key] = step3Change;
    this.setState({ ...this.state, step3 });
  };

  changeModelStep3AddressOther = ({ key }) => {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    insures[key] = {
      ...insures[key],
      sNo: "",
      sMoo: "",
      sSoi: "",
      sRoad: "",
      sProvince: "",
      sDistrict: "",
      sCity: "",
      sZipcode: "",
    };
    step3.insures = insures;
    this.setState({ ...this.state, step3 });
  };

  changeModelStep3Benefit = ({ key, index, name, value }) => {
    const { step3 } = this.state;
    const { insures } = step3 || {};
    insures[key].benefits[index][name] = value;
    step3.insures = insures;
    this.setState({ ...this.state, step3 });
  };

  changeModelStep4Insurance = ({ name, value }) => {
    const { step4 } = this.state;
    step4[name] = value;
    this.setState({ ...this.state, step4 });
  };

  changeEditUser = ({ name, value }) => {
    const { step4 } = this.state;
    step4[name] = value;
    this.setState({ ...this.state, step4 });
    this.setState({ ...this.state, page: 3 }, () => window.scrollTo(0, 0));
  };

  changeModelStep7 = ({ name, value }) => {
    const { step7 } = this.state;
    step7[name] = value;
    this.setState({ ...this.state, step7 });
  };

  checkDisbledNextButton() {
    const { page } = this.state;
    if (page === 1) {
      const { step1 } = this.state;
      const {
        type,
        start_date,
        end_date,
        purposeTour,
        purposeTourOther,
        // usertype,
        destinationCountry,
      } = step1 || {};
      if (
        !type ||
        !start_date ||
        !end_date ||
        !purposeTour ||
        // !usertype ||
        !destinationCountry
      ) {
        return true;
      } else if (purposeTour && purposeTour.value === "อื่นๆ" && !purposeTourOther) {
        return true;
      }
      return false;
    } else if (page === 2) {
      const { step2 } = this.state;

      const { selectedPlan, acceptInsurance, acceptHealthCheck } = step2 || {};
      if (!selectedPlan || !acceptInsurance || !acceptHealthCheck) {
        return true;
      } else {
        return false;
      }
    } else if (page === 3) {
      const { step1, step3 } = this.state;
      const { insures } = step3 || {};
      const { counter } = step1;
      for (let i = 0; i < counter; i++) {
        const {
          sNationality,
          sIDNo,
          sPassportNo,
          sExpiryDate,
          sSex,
          sInitNameTH,
          sFirstNameTH,
          sLastNameTH,
          sInitNameEN,
          sFirstNameEN,
          sLastNameEN,
          sBirthDate,
          sMobile,
          sEmail,
          sNo,
          sProvince,
          sDistrict,
          sCity,
          sZipcode,
          isHeirBenefit,
          benefits,
          isSameIdentity,
        } = insures[i];
        if (i > 0) {
          if (!isSameIdentity) {
            return true;
          }
          if (isSameIdentity === 2) {
            if (!sNo || !sProvince || !sDistrict || !sCity || !sZipcode) {
              return true;
            }
          }
        }
        if (
          !sNationality ||
          !sSex ||
          !sInitNameTH ||
          !sFirstNameTH ||
          !sLastNameTH ||
          !sInitNameEN ||
          !sFirstNameEN ||
          !sLastNameEN ||
          !sBirthDate ||
          !sMobile ||
          !sEmail
        ) {
          return true;
        }
        if (sNationality && sNationality.value === "THA") {
          if (!sIDNo) {
            return true;
          }
        }
        if (sNationality && sNationality.value !== "THA") {
          if (!sPassportNo || !sExpiryDate) {
            return true;
          }
        }
        if (!isHeirBenefit) {
          return true;
        }
        if (isHeirBenefit === 2) {
          for (let i = 0; i < benefits.length; i++) {
            if (!benefits[i].sInit || !benefits[i].sFirstName || !benefits[i].sLastName || !benefits[i].sRelation) {
              return true;
            }
          }
        }
      }
    } else if (page === 4) {
      const { step4 } = this.state;
      const { recieveEmail, recievePost, confirmInsurance } = step4;

      if (!confirmInsurance) {
        return true;
      }
      if (!recieveEmail && !recievePost) {
        return true;
      } else {
        return false;
      }
    }
  }

  _validForm(idCard) {
    let check = true;
    if (!IdentityUtils.validateIdentity(idCard)) {
      check = false;
    }
    return check;
    // const { step3 } = this.state;
    // let check = true;
    // step3.insures.map((i, index) => {
    //   if (!IdentityUtils.validateIdentity(i.sIDNo)) {
    //     check = false;
    //   }
    // });
    // return check;
  }

  _validEmail() {
    const { step3 } = this.state;
    let check = true;
    step3.insures.map((i, index) => {
      if (!IdentityUtils.validateEmail(i.sEmail)) {
        check = false;
      }
    });
    return check;
  }

  _onVerifyOrder() {
    const { step1, step2, step3, step4 } = this.state;
    const { recieveEmail = false, recievePost = false } = step4;
    const { insures } = step3;
    const planDetail = step2.planList.filter((plan) => plan.id === step2.selectedPlan)[0];
    const personalAssurances = step3.insures.map((i, index) => {
      let benefit = {};
      i.benefits.map((be, index) => {
        const seq = index + 1;
        benefit[`objBeneficiary${seq}`] = {
          sBeneficiarySeq: seq,
          sInit: be.sInit ? be.sInit.label : "",
          sFirstName: be.sFirstName ? be.sFirstName : "ทายาทตามกฎหมาย",
          sLastName: be.sLastName ? be.sLastName : "",
          sRelationID: be.sRelation ? be.sRelation.value : "R19",
          sRelation: be.sRelation ? be.sRelation.label : "ทายาทตามกฎหมาย",
        };
      });
      return {
        sApplicantSeq: index + 1,
        sType: "A",
        sPersonType: "P",
        sInitNameTH: i.sNationality.value === "THA" ? i.sInitNameTH.label : i.sInitNameEN.label,
        sFirstNameTH: i.sNationality.value === "THA" ? i.sFirstNameTH : i.sFirstNameEN,
        sLastNameTH: i.sNationality.value === "THA" ? i.sLastNameTH : i.sLastNameEN,

        sInitNameEN: i.sInitNameEN.label,
        sFirstNameEN: i.sFirstNameEN,
        sLastNameEN: i.sLastNameEN,

        sIDNo:
          i.sNationality.value === "THA" && i.sIDNo ? i.sIDNo.replace(/-/g, "") : i.sPassportNo ? i.sPassportNo : "",
        sIDType: i.sNationality.value === "THA" ? "ID card" : "Passport",
        sSex: i.sSex,

        // sOccupationID: i.sOccupation.value,
        // sOccupation: i.sOccupation.label,
        sEmail: i.sEmail,

        sRDConsent: "",
        sNationality: i.sNationality.value,
        sBirthDate: moment(i.sBirthDate).format("YYYY/MM/DD"),
        objApplicantAddress: {
          sType: "A",
          sBuilding: i.sBuilding ? i.sBuilding : !i.sBuilding && i.isSameIdentity === 1 ? insures[0].sBuilding : "",
          sVillage: i.sBuilding ? i.sBuilding : !i.sBuilding && i.isSameIdentity === 1 ? insures[0].sBuilding : "",
          sNo: i.sNo ? i.sNo : !i.sNo && i.isSameIdentity === 1 ? insures[0].sNo : "",
          sMoo: i.sMoo ? i.sMoo : !i.sMoo && i.isSameIdentity === 1 ? insures[0].sMoo : "",
          sSoi: i.sSoi ? i.sSoi : !i.sSoi && i.isSameIdentity === 1 ? insures[0].sSoi : "",
          sRoad: i.sRoad ? i.sRoad : !i.sRoad && i.isSameIdentity === 1 ? insures[0].sRoad : "",
          sProvince: i.sProvince.label
            ? i.sProvince.label
            : !i.sProvince.label && i.isSameIdentity === 1
            ? insures[0].sProvince.label
            : "",
          sCity: i.sDistrict.label
            ? i.sDistrict.label
            : !i.sDistrict.label && i.isSameIdentity === 1
            ? insures[0].sDistrict.label
            : "",
          sDistrict: i.sCity.label ? i.sCity.label : !i.sCity.label && i.isSameIdentity === 1 ? insures[0].sCity.label : "",
          sZipcode: i.sZipcode ? i.sZipcode : !i.sZipcode && i.isSameIdentity === 1 ? insures[0].sZipcode : "",
        },
        ...benefit,
      };
    });
    const { sEmail, sMobile } = step3.insures[0];
    const { counter, destinationCountry, countryZone } = step1;
    let zone = "ASIA-THAILAND";
    let groupCountry = { schengen: false, worldwide: false }
    let destCountryList = destinationCountry.map(country => {
      if (country.group == 'SCHENGEN') groupCountry.schengen = true;
      if (country.group == 'WORLDWIDE') groupCountry.worldwide = true;
      return country.value 
    });
    if (groupCountry.worldwide) zone = "WORLDWIDE-THAILAND";
    if (groupCountry.schengen) zone = "SCHENGEN GROUP COUNTRIES-THAILAND";
    let destCountry = `THAILAND-${destCountryList.toString()}/${zone}`
    const objRequest = {
      objMaster: {
        sProductCode: "MTI06200_AOT",
        sPackageCode: planDetail.packageCode,
        // planName: planDetail.name,
        planName: planDetail.product_name + ` (แผน ${planDetail.group_2})`,
        sPackagePremium: planDetail.price,
        sTotalPremium: planDetail.total,
        sStamp: planDetail.stamp,
        sVat: planDetail.vat,
        sBKOrderNo: CookieUtils.getCookie("app_bk_no"), //uId ,"AOT_KD_TEST_X002"
        sFromDate: moment(step1.start_date).format("YYYY/MM/DD"),
        sToDate: moment(step1.end_date).format("YYYY/MM/DD"),

        sCountriesEN: destCountry, // destination country
        sSendDocBy: sEmail, // user's email
        sContactMT: sMobile, // user's phone no.
        sDeliveryTo: recieveEmail && recievePost ? "Both" : recieveEmail ? "Email" : "POST", // deliveryTo
        lstObjOptional: [],
        // lstObjOptional: [{
        //   sOptionalCode: 'TRV',//planDetail.packageCode,
        //   sOptionalDesc: planDetail.name,
        //   sOptionalPremium: planDetail.total
        // }]
      },
      lstObjApplicantPerson: personalAssurances,
      objStep: {
        step1,
        step2,
        step3,
        step4,
      },
    };

    console.log(objRequest);

    Alert.showLoading();
    OrderService.orderVerify(objRequest)
      .then((res) => {
        Alert.hideLoading();
        if (res.info.bSuccess && res.hash) {
          const { step5 } = this.state;
          step5.paymentModel = res.hash;
          this.setState({ ...this.state, page: 5, step5 }, () => window.scrollTo(0, 0));
        } else if (!res.info.bSuccess) {
          console.log("Not completed:", res.info.lstObjResultKey[0].resultDesc.sDescTH);
          if (res.info.lstObjResultKey[0].resultDesc.sMTICode.includes("E")) {
            Alert.alertMessage(
              "กรุณากรอกข้อมูลให้ถูกต้อง",
              "ขออภัยค่ะ คุณสมบัติของท่านไม่เป็นไปตามเงื่อนไขการรับประกันภัย กรุณาติดต่อเจ้าหน้าที่ที่เบอร์ 1484 หรือฝากข้อมูลให้เจ้าหน้าที่ติดต่อกลับ",
              "warning",
              "true",
              "ติดต่อเจ้าหน้าที่",
              "true",
              "ยกเลิก",
            )
            .then(res => {
              if (res === "option1") {
                this.onNavigate(7);
              }
            });
          } else {
            Alert.alertWithTitle("กรุณาทำรายการใหม่อีกครั้ง", res.info.lstObjResultKey[0].resultDesc.sDescTH, "warning");
          }
        }
      })
      .catch((err) => {
        Alert.hideLoading();
      });
  }

  getDiffDate() {
    const { start_date, end_date } = this.state.step1;

    return start_date && end_date ? moment(end_date).diff(moment(start_date), "days") + 1 : "-";
  }

  

  render() {
    const { showErroModal, errorTitle, errorMessage, steps, page, step1, step2, step3, step4, step5, step6, step7 } =
      this.state;
    const isDisabledNext = this.checkDisbledNextButton();
    const diffDate = this.getDiffDate();
    return (
      <Fragment>
        {page > 0 && page < 5 ? <StepToShowComponent steps={steps} currentPage={page} /> : ""}
        {page === 0 && <ConsentPage />}
        {page === 1 && (
          <SawasdeeProvider value={{ step1, diffDate }}>
            <InternationalStep1 />
          </SawasdeeProvider>
        )}
        {page === 2 && (
          <SawasdeeProvider value={{ step2, diffDate, step1 }}>
            <InternationalStep2 />
          </SawasdeeProvider>
        )}
        {page === 3 && (
          <SawasdeeProvider value={{ step3, step1, step4 }}>
            <InternationalStep3 />
          </SawasdeeProvider>
        )}
        {page === 4 && (
          <SawasdeeProvider value={{ step1, step2, step3, diffDate, step4 }}>
            <InternationalStep4 />
          </SawasdeeProvider>
        )}
        {page === 5 && (
          <SawasdeeProvider value={{ step1, step2, step3, step4, step5, diffDate }}>
            <InternationalStep5 />
            <div className="graphic">
              <img src={DecoratedGraphic} className="graphic-img" alt="span image" />
            </div>
          </SawasdeeProvider>
        )}
        {page === 0 && (
          <>
            <button
              className="form-control btn-primary floating-buy"
              disabled={isDisabledNext}
              onClick={() => this.onNavigate(page + 1)}
            >
              ซื้อประกัน
            </button>
          </>
        )}
        {page === 6 && (
          <SawasdeeProvider value={{ step1, step2, step3, step4, step5, step6 }}>
            <InternationalStep6 />
          </SawasdeeProvider>
        )}
        {page === 7 && (
          <SawasdeeProvider value={{ step7 }}>
            <InternationalStep7 />
          </SawasdeeProvider>
        )}
        {page > 0 && page < 5 && (
          <div className="form-wrapper d-flex mt-0 mb-5">
            <button className="form-control" onClick={() => this.onNavigate(page - 1)}>
              ย้อนกลับ
            </button>
            <SpaceBox w="12px" />
            <button
              className="form-control btn-primary"
              disabled={isDisabledNext}
              onClick={() => this.onNavigate(page + 1)}
            >
              ถัดไป
            </button>
          </div>
        )}
        <PaymentErrorModalComponent
          show={showErroModal}
          title={errorTitle}
          message={errorMessage}
          hideModal={() => this.setState({ ...this.state, showErroModal: false })}
        />
      </Fragment>
    );
  }
}

export default withRouter(InternationalPage);
